/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUasHomePoint = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M14 6s-.5 0-1-1-1-1-1-1H7S5 4 5 6v14h2.133L7 14h4s.5 0 1 1 1 1 1 1h6V6zm3 8h-3s-.5 0-1-1-1-1-1-1H7V6h4s.5 0 1 1 1 1 1 1h4z" /></svg>;
export default SvgUasHomePoint;